// extracted by mini-css-extract-plugin
export default {"container":"register_container__ZjMTA","header":"register_header__o1dBS","inputContainer":"register_inputContainer__Qf6mc","buttonContainer":"register_buttonContainer__Pqxst"};